import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const state = {
  products: [],
  sectors: [],
  noSectorProducts: [],
  sectorMap: null,
  selectedInfo: false,
  selectedSector: null,
  tempSelectedSector: null,
  cartProducts: [],
  cupomCode: '',
  isValidCupomCode: false,
  isCupomTracking: null,
  hasCupom: false,
  isSpecialCupom: false,
  isCupomCard: false,
  productsAll: [],
  cupomData: null,
  showQueue: false,
  saleUninitiated: false,
  passedQueue: false,
  messageQueue: false,
  positionQueue: null,
  productsNoGroup: null,
  cupomMessage: null,
  separateProducts: null,
  maxCartCoupon: null,
  ticketCodeUrl: null,
  productsCodeUrl: null,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
